import { Injectable } from '@angular/core';
import { HttpHeaders, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { 
  ODataClient,
  ODataEntityService, 
  ODataEntity, 
  ODataEntities, 
  ODataProperty, 
  EntityKey,
  Duration,
  ODataEntityResource,
  ODataEntitySetResource,
  ODataNavigationPropertyResource,
  ODataActionResource,
  ODataFunctionResource,
  HttpOptions
} from 'angular-odata';

//#region ODataApi Imports
import { Group } from '../entities/schema/group.entity';
import { ProduktTypGroup } from '../entities/produkte/produkttypgroup.entity';
import { ProduktTyp } from '../entities/produkte/produkttyp.entity';
import { Status } from '../entities/settings/status.entity';
import { StatusType } from '../entities/settings/statustype.entity';
//#endregion

@Injectable()
export class ProduktTypGroupService extends ODataEntityService<ProduktTypGroup> {
  constructor(protected client: ODataClient) {
    super(client, 'ProduktTypGroup', 'entities.produkte.ProduktTypGroup');
  }

  
  
  //#region ODataApi Actions
  //#endregion
  //#region ODataApi Functions
  //#endregion
  //#region ODataApi Navigations
  public group(entity: EntityKey<ProduktTypGroup>): ODataNavigationPropertyResource<Group> {
    return this.entity(entity).navigationProperty<Group>('group');
  }
  public produktTyp(entity: EntityKey<ProduktTypGroup>): ODataNavigationPropertyResource<ProduktTyp> {
    return this.entity(entity).navigationProperty<ProduktTyp>('produktTyp');
  }
  public status(entity: EntityKey<ProduktTypGroup>): ODataNavigationPropertyResource<Status> {
    return this.entity(entity).navigationProperty<Status>('status');
  }
  public statusType(entity: EntityKey<ProduktTypGroup>): ODataNavigationPropertyResource<StatusType> {
    return this.entity(entity).navigationProperty<StatusType>('statusType');
  }
  //#endregion
}
